/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Previous_WeekInputs */



/**
* | output |
* | --- |
* | "Previous week" |
*
* @param {Agenda_Previous_WeekInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_previous_week = /** @type {((inputs?: Agenda_Previous_WeekInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Previous_WeekInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Vorige week")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Semaine précédente")
	return /** @type {LocalizedString} */ ("Previous week")
});